var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-pass-wrapper" }, [
    _c("input", {
      attrs: { id: _vm.id, type: _vm.type },
      on: { input: _vm.handleInput },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.toggleInputType()
          },
        },
      },
      [
        _c(
          "svg",
          {
            class: { active: _vm.type === "password" },
            attrs: { viewBox: "0 0 240 144" },
          },
          [
            _c("path", {
              attrs: {
                d: "M120,112a40,40,0,1,1,40-40A40,40,0,0,1,120,112Zm0-72a32,32,0,1,0,32,32A32,32,0,0,0,120,40Z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "cls-1",
              attrs: {
                d: "M120,144A137.09,137.09,0,0,1,.51,74a4,4,0,0,1,0-3.9,136.94,136.94,0,0,1,239,0,4,4,0,0,1,0,3.9A137.09,137.09,0,0,1,120,144ZM8.61,72a128.94,128.94,0,0,0,222.78,0A128.94,128.94,0,0,0,8.61,72Z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            class: { active: _vm.type === "text" },
            attrs: { viewBox: "0 0 240 192" },
          },
          [
            _c("path", {
              attrs: {
                d: "M239.49,94a136.67,136.67,0,0,0-46.16-48.63,4,4,0,0,0-4.26,6.78A128.42,128.42,0,0,1,231.39,96,129.09,129.09,0,0,1,120,160a126.56,126.56,0,0,1-37.15-5.5,4,4,0,1,0-2.34,7.64A134.23,134.23,0,0,0,120,168,137.09,137.09,0,0,0,239.49,98,4,4,0,0,0,239.49,94Z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M97.41,124.25v0L214.83,6.83a4,4,0,0,0-5.66-5.66L174.8,35.54A134.46,134.46,0,0,0,120,24,137.09,137.09,0,0,0,.51,94.05a4,4,0,0,0,0,3.9,135.4,135.4,0,0,0,57,54.88L25.17,185.17a4,4,0,0,0,5.66,5.66l66.56-66.56Zm-2.68-8.63A31.57,31.57,0,0,1,88,96a32,32,0,0,1,32-32,31.53,31.53,0,0,1,19.62,6.73ZM8.61,96A129.1,129.1,0,0,1,120,32a126.55,126.55,0,0,1,48.71,9.63L145.31,65A39.45,39.45,0,0,0,120,56,40,40,0,0,0,80,96a39.45,39.45,0,0,0,9,25.31L63.5,146.84A127.35,127.35,0,0,1,8.61,96Z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M120,128a32.86,32.86,0,0,1-6.5-.64,4,4,0,0,0-1.57,7.84A40.1,40.1,0,0,0,160,96a41.32,41.32,0,0,0-.79-8.06,4,4,0,0,0-7.85,1.56A33.16,33.16,0,0,1,152,96,32,32,0,0,1,120,128Z",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }